import useLogicalProducts from "../../../hooks/useLogicalProducts";
import { getImageUrl } from "../../../utils";
import { Widget } from "../../../widgetList/widgetList";
import { ThreeBannersProducts } from "../../Widgets/Banner";
import ProductCard from "../ProductCard";
import classes from "./ProductWithThreeBanner.module.css";

const ProductWithThreeBanner = ({ widget }: { widget?: Widget }) => {
	const { products, loading, error } = useLogicalProducts({
		widget,
	});

	const banner1 = widget?.data?.rightImages?.rightImageOne;
	const banner2 = widget?.data?.rightImages?.rightImageTwo;
	const featuredBanner: any = {
		title: widget?.title || "",
		image: widget?.featuredImage || "",
		link: (widget as any)?.fetchuredImageUrl || {},
	};

	const settings = widget?.data?.settings || {};

	if (loading || products.length === 0) return <ThreeBannersProducts />;

	return (
		<section className={`${classes.ProductWithThreeBanner}`}>
			<div className="container">
				<div className={classes.body}>
					<div className="xl:flex gap-2 mb-2 xl:mb-4">
						<div className={classes.products}>
							{products.slice(0, 4).map((product, i) => (
								<ProductCard
									key={i}
									productItem={product}
									settings={settings}
								/>
							))}
						</div>

						<div className={classes.banners}>
							{[banner1, banner2].map((banner, i) => (
								<div key={i} className={classes.banner}>
									<img
										src={getImageUrl(banner?.image || "")}
										style={{
											aspectRatio: 315 / 200,
											objectFit: "cover",
											// height: `${pHeight / 2}px`,
										}}
									/>
								</div>
							))}
						</div>
					</div>

					<div className={classes.banner}>
						<img
							src={getImageUrl(featuredBanner?.image || "")}
							alt="banner"
							className="w-full"
							style={{
								aspectRatio: 1320 / 355,
								objectFit: "cover",
							}}
						/>
					</div>
				</div>
			</div>
		</section>
	);
};

export default ProductWithThreeBanner;
